module.exports = __webpack_public_path__ + "img/newlogo-150.631d6c03.jpg";